import React from 'react';
import { ExternalLink, Globe, Smartphone } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { portfolioData } from '../mock';

const Projects = () => {
  const { projects } = portfolioData;

  return (
    <section id="projects" className="py-16 sm:py-24 bg-slate-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
              Live Projects
            </h2>
            <p className="text-gray-400 text-base sm:text-lg">Apps available on App Store & Play Store</p>
          </div>

          {/* Projects Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
            {projects.map((project) => (
              <Card
                key={project.id}
                className="bg-slate-800/50 border-slate-700 hover:border-cyan-400/50 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-400/10 group"
              >
                <CardHeader>
                  <div className="flex items-start justify-between mb-2">
                    <CardTitle className="text-2xl font-bold text-white group-hover:text-cyan-400 transition-colors">
                      {project.name}
                    </CardTitle>
                    {/* <Badge className="bg-green-500/10 text-green-400 border-green-400/30">
                      {project.status}
                    </Badge> */}
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    {project.description}
                  </p>

                  {/* Technologies */}
                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-400 mb-3">Technologies Used</h4>
                    <div className="flex flex-wrap gap-2">
                      {project.technologies.map((tech, idx) => (
                        <span
                          key={idx}
                          className="text-xs px-3 py-1 bg-cyan-400/10 text-cyan-400 rounded-full border border-cyan-400/30"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Store Links */}
                  <div className="flex flex-col sm:flex-row gap-3">
                    {project.appStoreLink && (
                      <Button
                        variant="outline"
                        className="flex-1 border-slate-600 hover:border-cyan-400 hover:bg-cyan-400/10 text-gray-300 hover:text-cyan-400 transition-all duration-300"
                        onClick={() => window.open(project.appStoreLink, '_blank')}
                      >
                        <Smartphone size={18} className="mr-2" />
                        App Store
                      </Button>
                    )}
                    {project.playStoreLink && (
                      <Button
                        variant="outline"
                        className="flex-1 border-slate-600 hover:border-cyan-400 hover:bg-cyan-400/10 text-gray-300 hover:text-cyan-400 transition-all duration-300"
                        onClick={() => window.open(project.playStoreLink, '_blank')}
                      >
                        <Smartphone size={18} className="mr-2" />
                        Play Store
                      </Button>
                    )}
                    {project.websiteLink && (
                      <Button
                        variant="outline"
                        className="flex-1 border-slate-600 hover:border-cyan-400 hover:bg-cyan-400/10 text-gray-300 hover:text-cyan-400 transition-all duration-300"
                        onClick={() => window.open(project.websiteLink, '_blank')}
                      >
                        <Globe size={18} className="mr-2" />
                        Visit Website
                      </Button>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;